import React, { FC } from 'react'
import styled from 'styled-components'
import { Grid } from 'semantic-ui-react'
import { translate } from 'loankeeper-common/helpers'
import { loadFont } from 'loankeeper-common/helpers/styles'
//@ts-ignore
import { GridContainer } from 'shared/StyledComponents'

import HistoryButton from '../shared/HistoryButton'

const StyledGridContainer = styled(GridContainer)`
  .modal-grid-container {
    height: 42px;
    padding: 4px 0px;
    vertical-align: middle;
    color: white;
    background: #007bff;
  }

  .modal-grid-container .order-header-text {
    ${loadFont('16px Noto Serif SemiCondensed Bold')};
  }
`

const Header: FC<{
  FormName: string
  name: string
}> = ({ FormName, name }) => (
  <StyledGridContainer>
    <Grid className="modal-grid-container">
      <Grid.Row>
        <Grid.Column width={2} />

        <Grid.Column width={12} textAlign="center" verticalAlign="middle">
          <p className="order-header-text">{translate('frm_acc_entry_add-lbl_ot_memorder')}</p>
        </Grid.Column>

        <Grid.Column width={2} textAlign="right">
          <HistoryButton FormName={FormName} name={`${name}-historyModal`} />
        </Grid.Column>
      </Grid.Row>
    </Grid>
  </StyledGridContainer>
)

export default Header
